import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import Axios from 'axios'
import './database.js'


import './assets/styles/style.css'
import './assets/styles/framework.css'
import './assets/fonts/css/fontawesome-all.min.css'

import VueSocialSharing from 'vue-social-sharing'

Vue.prototype.$http = Axios;

const token = localStorage.getItem('user-token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  VueSocialSharing,
  render: h => h(App)
}).$mount('#app')
